module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.7c3141b3.woff";